import Container from '@v2/shared/components/Container';
import Currency from '@v2/shared/components/Currency';
import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Product } from '@v2/shared/lib/types';
import { useSite } from '@v2/shared/lib/site';
import CTA from './CTA';
import mobileTablet from './images/mobile-tablet.png';

type Props = {
  product: Product;
  addToCart: () => void;
  isAdding: boolean;
};

/**
 * The second ask, at the foot of the page, for a visitor who scrolled past the hero's.
 * The same action and the same price as the hero — it is one button in two places.
 */
export default function StartTodayPanel({ product, addToCart, isAdding }: Props) {
  const { currency } = useSite();

  return (
    <div className="grid justify-center bg-zinio-purple-100">
      <Container className="grid grid-cols-1 lg:grid-cols-2 pt-12 pb-0 lg:py-0">
        <span className="flex justify-center items-start flex-col">
          <h2 className="text-zinio-purple-900 text-4xl md:text-4xl lg:text-3xl xl:text-5xl mb-5 lg:mb-10 font-bold max-w-xl">
            Start ZINIO Unlimited today
          </h2>
          <p className="text-zinio-purple-900 text-xl font-semibold mb-8">
            Read on any device. Cancel anytime. Just{' '}
            <span className="font-bold">
              <Currency value={product.base_sku?.price ?? 0} currencyCode={currency} />
            </span>
            /month.
          </p>
          <CTA size="lg" dark iconAfter={faLongArrowRight} onClick={addToCart} isLoading={isAdding} loadingText="Adding to cart...">
            Start free 1-month trial
          </CTA>
        </span>
        <span className="w-full h-full flex items-center justify-center">
          <img
            src={mobileTablet}
            alt="Zinio Unlimited app on mobile and tablet"
            width={2550}
            height={2332}
            className="w-full h-auto"
          />
        </span>
      </Container>
    </div>
  );
}
